'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const WalletLineChart = dynamic(() => import('./WalletLineChart'), { ssr: false });

interface WalletBalanceChartProps {
  currency: string;
  symbol: string;
}

export default function WalletBalanceChart({ symbol }: WalletBalanceChartProps) {
  return (
    <div className="rounded-xl p-5" style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-base font-bold text-foreground">Balance History</h3>
          <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>Last 30 days · Available balance trend</p>
        </div>
        <div className="flex items-center gap-4 text-xs">
          <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full" style={{ background: '#7C3AED' }} />Balance</span>
          <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full" style={{ background: '#10B981' }} />Winnings</span>
        </div>
      </div>
      <WalletLineChart symbol={symbol} />
    </div>
  );
}